import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import FilterBase from '@/components/filters/FilterBase'
import styles from '@/components/filters/SortingFilter.module.css'

const SortingFilter = () => {
  const router = useRouter()
  const buttonName = 'Order by'
  const filterName = 'sorting'

  const options = [
    { value: 'make__name', label: 'Alphabetical (A to Z)' },
    { value: '-make__name', label: 'Alphabetical (Z to A)' },
    // { value: '3', label: 'Average New Range (High to Low)' },
    // { value: '4', label: 'Average New Range (Low to High)' },
  ]

  const [selectedOption, setSelectedOption] = useState(null)

  useEffect(() => {
    const { query } = router
    if (query[filterName]) {
      const selected = options.find((option) => option.value === query[filterName])
      if (selected) setSelectedOption(selected.value)
    }
  }, [router.query])

  const handleOptionSelected = (optionValue) => {
    const { query } = router
    setSelectedOption(optionValue)
    router.push({
      pathname: router.pathname,
      query: { ...query, [filterName]: optionValue },
    })
  }

  return (
    <FilterBase
      buttonName={
        selectedOption
          ? `${buttonName}: ${options.find((option) => option.value === selectedOption).label}`
          : buttonName
      }
    >
      {({ close }) => (
        <div className={styles.filters}>
          <div className={styles.subFilters}>
            {options.map((option) => (
              <div
                className={`${styles.filter} ${option.value === selectedOption ? styles.selected : ''}`}
                key={option.value}
                onClick={() => {
                  handleOptionSelected(option.value)
                  close()
                }}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </FilterBase>
  )
}

export default SortingFilter
